<template>
  <Head title="Integrations - Public File Upload" />
  
  <div class="container-fluid d-flex flex-column">
    <div class="row">
        <div class="container-fluid mt-4 ms-4">
            <Link class="navbar-brand" href="/">
                <img src="/img/logo_png/avid_logo_red.png" alt="Avid" class="logo">
            </Link>
        </div>
    </div>
    <div class="row justify-content-center flex-grow-1">
        <div class="col-9">
            <div class="row">
                <div class="col">
                    <h1 class="mt-5">Upload Files for {{ client.name }}</h1>
                    <p>Drag and drop your files in the area below to upload them into Avid. For the data files to be usable within the system, please be sure they are in a CSV, TSV, or TXT format.</p>
                    
                    <file-upload :client="client"></file-upload>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';

defineProps({
  client: Object
});
</script>

